import React from 'react';
import { Table } from 'antd';

const ProfilesTable = props => {
  const {
    isLoading,
    profiles,
    renderColumns,
    pageSize,
    handleChange,
    handleClickRow,
    rowKey,
    searchValue,
  } = props;

  return (
    <div className="employees__table">
      <Table
        loading={!profiles && isLoading}
        locale={{
          emptyText: !isLoading
            ? searchValue
              ? `Сотрудников по запросу «${searchValue}» нет`
              : 'Сотрудников нет'
            : null,
        }}
        dataSource={profiles}
        pagination={{ pageSize }}
        rowKey={rowKey}
        columns={renderColumns()}
        onChange={handleChange}
        onRow={record => {
          return {
            onClick: () => {
              handleClickRow(record.profileId);
            },
          };
        }}
      />
    </div>
  );
};

export default ProfilesTable;
